import axios from 'axios'
import { toast } from 'react-toastify'
import { StepperComponent } from '../../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../../_metronic/helpers'
import { constraintConfig } from '../../../../../constraintConfig'
import {
  useDepartmentsLookupQuery, useGetAllDivisionQuery,
  useGetAllLocationsQuery, useDesignationLookupQuery,
  useGetIsTravelModuleAccessAvailableQuery
} from '../../../../../services/UnauthApi'
import { useGetAllLst_UserExpenseTypeQuery } from '../../../../../services/GeneralApi'
import { API_END_POINTS } from '../../../../../services/apiEndpoints'
import labelKey from "../../../../localization/label.json"
import tosterKey from "../../../../localization/toster.json"
import { Step1 } from './steps/Step1'
import { Step3 } from './steps/Step3'
import { Step4 } from './steps/Step4'
import { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import { baseUrl } from '../../../../../services/baseUrl'
import { Link, useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../../../hooks'
import { selectAuth } from '../../../../../features/authSlice'


/* eslint-disable jsx-a11y/anchor-is-valid */

type PortalUserRegistrationProps = {
  /** Manager creates request: hide manager lookup, auto-set manager, auto-approve via API. */
  requestedByManager?: boolean
}

export function PortalUserRegistration({ requestedByManager = false }: PortalUserRegistrationProps) {
  const { roleID, token, userAccountID, email, firstName, lastName, isTravelModuleAccessAvailable: travelFromAuth } = useAppSelector(selectAuth);
  const { data: travelModuleFlag } = useGetIsTravelModuleAccessAvailableQuery('')
  const isTravelModuleAccessAvailable = !!(travelFromAuth || travelModuleFlag?.result)
  const navigate = useNavigate();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  const { data: departmentLookup, refetch: departmentRefetch } = useDepartmentsLookupQuery('');
  // const { data: designationLookup } = useDesignationLookupQuery(formik.values.role.roleID);
  const { data: locationsData, refetch: locationRefetch } = useGetAllLocationsQuery('')
  const { data: getAlldivision, refetch: divisionRefetch } = useGetAllDivisionQuery('')
  const { data: designationLookup, refetch: designationRefetch } = useDesignationLookupQuery('')
  const { data: expenseTypeLookup } = useGetAllLst_UserExpenseTypeQuery('', { skip: !roleID })

  const [isLoading, setIsLoading] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState(1);

  // Update handleClose function to check for team-management route
  const handleClose = () => {
    if (roleID && roleID > 0) {
      // Check if current location includes team-management
      const currentPath = window.location.pathname;
      if (currentPath.includes('/newuserrequestbymanager')) {
        // Navigate to team-management with state to activate second tab
        navigate('/team-management', { 
          state: { activeTab: 'second' } 
        });
      } else {
        navigate('/expense-users', { state: { activeTab: 'second' } });
      }
    } else {
      navigate('/auth/login');
    }
  };

  // Add this function in your component
  const handleSubmit = () => {
    // Validate the form first
    formik.validateForm().then(errors => {
      if (Object.keys(errors).length === 0) {
        formik.submitForm();
      } else {
        // Show validation errors
        toast.error('Please fill all required fields');
      }
    });
  };
  useEffect(() => {
    departmentRefetch()
    locationRefetch()
    divisionRefetch()
    designationRefetch()
  }, [departmentRefetch, locationRefetch, divisionRefetch, designationRefetch])

  // Update current step index when stepper changes
  useEffect(() => {
    if (stepper.current) {
      // Listen to stepper changes
      const updateStep = () => {
        if (stepper.current) {
          setCurrentStepIndex(stepper.current.currentStepIndex);
        }
      };

      // Initial update
      updateStep();

      // You might need to add event listener here if StepperComponent supports it
      // For now, we'll update on nextStep and prevStep calls
    }
  }, []);

  const currentDate = new Date();

  const initialValues = {
    orgId: 0,
    role: {
      roleID: 0,
      name: ''
    },
    expenseType: {
      id: 0,
      value: ''
    },
    userPermission: [
      {
        permissionId: 0,
        lst_PermissionId: 0,
        key: '',
        value: false
      }
    ],
    userType: {
      id: 0,
      value: ''
    },
    locationType: {
      id: 0,
      value: ''
    },
    department: {
      id: 0,
      title: ''
    },
    designation: {
      id: 0,
      title: ''
    },
    location: {
      id: 0,
      value: ''
    },
    division: {
      id: 0,
      title: ''
    },
    mgrApproveMaxLimit: 0,
    employeeId: '',
    dayforceId: '',
    userName: '',
    firstName: '',
    middleName: '',
    lastName: '',
    cellPhone: '',
    businessPhone: '',
    businessExt: '',
    active: true,
    managerId: 0,
    managerName: '',
    managerEmail: '',
    country: {
      id: 0,
      title: ''
    },
    // requestingAccountFor: {
    //   id: 0,
    //   value: ''
    // },
    accountType: {
      id: 0,
      title: ''
    },
    addressLine1: '',
    addressLine2: '',
    state: '',
    postalCode: '',
    latitude: '',
    longitude: '',
    city: '',
    findAddress: '',
    bcEmployeeId: '',
    reportPermision: false,
    excludeMileageCalculationLogic: false,
    excludeSupportUser: false,
    userTimeZone: {
      id: 0,
      title: ''
    },
    ccFeedFrom: currentDate,
    delegateManager: {
      id: 0,
      value: ''
    },
    delegateStartDate: '',
    delegateEndDate: '',
    allowImpersonation: false,
    isOrgUserImpersonate: false,
    requestTravelPortalAccess: false,
    requestCorporateCreditCard: false,
    spendingLimit: 0,
    orgUserImpersonate: []
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true); // Don't forget to set loading to true at start
      if (values.requestCorporateCreditCard) {
        const limit = Number(values.spendingLimit);
        if (!values?.location?.id) {
          toast.error('Ship To Address is required for Corporate Credit Card request.');
          setIsLoading(false);
          return;
        }
        if (!values?.division?.id) {
          toast.error('Division is required for Corporate Credit Card request.');
          setIsLoading(false);
          return;
        }
        if (!Number.isFinite(limit) || limit <= 0) {
          toast.error('Corp CC Limit must be greater than 0 for Corporate Credit Card request.');
          setIsLoading(false);
          return;
        }
        if (!values?.findAddress?.trim() || !values?.addressLine1?.trim()) {
          toast.error('Please correct address using Find Address and select a map result. This address will be used for your Corporate Credit Card for shipping.');
          setIsLoading(false);
          return;
        }
      }
      if (!values?.findAddress?.trim() || !values?.addressLine1?.trim() || !values?.city?.trim()) {
        toast.error('Please correct address using Find Address and select a result from the map suggestions.');
        setIsLoading(false);
        return;
      }

      // Map FE field names to API (RequestCorporateCreaditCard spelling + SpendingLimit)
      // Normalize lookup objects so id 0 / empty are sent as null (avoid persisting bogus 0 IDs)
      const normalizeLookup = (obj: any) => {
        if (!obj || !obj.id || Number(obj.id) <= 0) return null;
        return obj;
      };
      const payload = {
        ...values,
        managerEmail: values.managerEmail || (
          typeof values.managerName === 'string' && values.managerName.includes('@')
            ? (values.managerName.includes('-') && /^\d+-/.test(values.managerName)
              ? values.managerName.substring(values.managerName.indexOf('-') + 1)
              : values.managerName)
            : ''
        ),
        location: normalizeLookup(values.location),
        department: normalizeLookup(values.department),
        designation: normalizeLookup(values.designation),
        division: normalizeLookup(values.division),
        userTimeZone: normalizeLookup(values.userTimeZone),
        expenseType: normalizeLookup(values.expenseType),
        userType: normalizeLookup(values.userType),
        requestCorporateCreaditCard: !!values.requestCorporateCreditCard,
        requestTravelPortalAccess: isTravelModuleAccessAvailable ? !!values.requestTravelPortalAccess : false,
        spendingLimit: values.requestCorporateCreditCard ? Number(values.spendingLimit) : null,
        cellPhone: values.cellPhone?.replace(/[_]/g, '').replace(/^-+$/, '') || values.cellPhone || '',
        businessPhone: values.businessPhone?.replace(/[_]/g, '').replace(/^-+$/, '') || values.businessPhone || '',
      };

      try {
        const endpoint = requestedByManager
          ? `${baseUrl.MAIN_BASE_URL}/api/Account/CreateUserDraftByManager`
          : `${baseUrl.MAIN_BASE_URL}/api/Account/CreateUserRequest`;
        const headers: Record<string, string> = {
          'Content-Type': 'application/json',
        };
        if (requestedByManager && token) {
          headers.Authorization = `Bearer ${token}`;
        }
        const response = await axios.post(
          endpoint,
          payload,
          { headers }
        );
        if (response.data && response.data.success) {
          toast.success(response.data?.message);
          // resetForm(); // Reset form on success
          if (roleID) {
            handleClose();
          }
        } else {
          const errorMsg = response.data?.message || '';
          toast.error(errorMsg);
        }
      } catch (error: any) {
        var errorMessage = 'Unable to create user. Please contact system admin!'
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        }
        toast.error(errorMessage);
      } finally {
        setIsLoading(false);
      }
    },
  });

  // Manager request: lock manager to the logged-in user
  useEffect(() => {
    if (!requestedByManager || !userAccountID) return;
    const displayName = [firstName, lastName].filter(Boolean).join(' ').trim() || email || '';
    formik.setFieldValue('managerId', userAccountID);
    formik.setFieldValue('managerEmail', email || '');
    formik.setFieldValue('managerName', displayName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedByManager, userAccountID, email, firstName, lastName]);

  const { resetForm } = formik;

  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
    setCurrentStepIndex(stepper.current.currentStepIndex);
  }

  const nextStep = () => {
    if (!stepper.current) {
      return;
    }
    if (stepper.current.currentStepIndex === 1) {
      if (!requestedByManager && !formik.values.managerId) {
        toast.error('Manager is required.');
        return;
      }
      // else if (!formik.values?.requestingAccountFor?.id) {
      //   toast.error('Request account for is required.');
      //   return;
      // }
      else if (!formik.values?.expenseType?.id) {
        toast.error('Expense account type for is required.');
        return;
      }
      else if (!formik.values?.userType?.id) {
        toast.error('User type is required.');
        return;
      }
      else if (!formik.values?.location?.id) {
        toast.error(tosterKey.locationIsRequired);
        return;
      }
      else if (!formik.values?.division?.id) {
        toast.error('Division is required.');
        return;
      }
      else if (requestedByManager && !formik.values?.department?.id) {
        toast.error('Department is required.');
        return;
      }
      else if (requestedByManager && !formik.values?.designation?.id) {
        toast.error('Designation is required.');
        return;
      }
      if (formik.values.requestCorporateCreditCard) {
        const limit = Number(formik.values.spendingLimit);
        if (!Number.isFinite(limit) || limit <= 0) {
          toast.error('Corp CC Limit must be greater than 0 for Corporate Credit Card request.');
          return;
        }
      }
      if (!formik.values?.userName?.trim()) {
        toast.error(tosterKey.emailIsRequired);
        return;
      } else if (!/^\S+@\S+\.\S+$/.test(formik.values.userName)) {
        toast.error('Invalid email format.');
        return;
      }
      else if (!formik.values?.firstName?.trim()) {
        toast.error('First Name is required.');
        return;
      } else if (!formik.values?.lastName?.trim()) {
        toast.error('Last Name is required.');
        return;
      }
      else if (!formik.values?.dayforceId?.trim()) {
        toast.error('Dayforce ID is required.');
        return;
      }
      else if (!formik.values?.userTimeZone?.id) {
        toast.error(tosterKey.timeZoneIsRequired);
        return;
      }
    }
    else if (stepper.current.currentStepIndex === 2) {
      if (!formik.values?.findAddress?.trim()) {
        toast.error('Please search and select an address using Find Address.');
        return;
      }
      if (!formik.values?.addressLine1?.trim() || !formik.values?.city?.trim() || !formik.values?.latitude) {
        toast.error('Please correct the address using Find Address and select a result from the map suggestions. Address Line 1, City, and coordinates must be filled from the selected address.');
        return;
      }
      if (formik.values.requestCorporateCreditCard) {
        if (!formik.values?.findAddress?.trim() || !formik.values?.addressLine1?.trim()) {
          toast.error('A valid Find Address selection is required because this address will be used for your Corporate Credit Card for shipping.');
          return;
        }
      }
    }
    stepper.current.goNext();
    setCurrentStepIndex(stepper.current.currentStepIndex);
  };

  // Helper function to check if step is active
  const isStepActive = (stepNumber: number) => {
    return currentStepIndex === stepNumber;
  };

  // Helper function to check if step is completed
  const isStepCompleted = (stepNumber: number) => {
    return currentStepIndex > stepNumber;
  };

  // Helper function to get step class based on state
  const getStepClass = (stepNumber: number) => {
    if (isStepActive(stepNumber)) return 'current';
    if (isStepCompleted(stepNumber)) return 'completed';
    return '';
  };

  // Helper function to get step circle style based on state
  const getStepCircleStyle = (stepNumber: number) => {
    if (isStepActive(stepNumber)) {
      return {
        backgroundColor: '#009EF7',
        border: 'none',
        width: '28px',
        height: '28px'
      };
    } else if (isStepCompleted(stepNumber)) {
      return {
        backgroundColor: '#50CD89',
        border: 'none',
        width: '28px',
        height: '28px'
      };
    } else {
      return {
        backgroundColor: 'transparent',
        border: '1px solid var(--bs-border-color, #E4E6EF)',
        width: '28px',
        height: '28px'
      };
    }
  };

  // Helper function to get step text color based on state
  const getStepTextColor = (stepNumber: number) => {
    if (isStepActive(stepNumber)) return 'text-primary';
    if (isStepCompleted(stepNumber)) return 'text-success';
    return 'text-muted';
  };

  // Check if we're on the last step
  const isLastStep = currentStepIndex === 3;

  return (
    <>
      <div className="min-vh-100 d-flex flex-column p-0 ss-portal-user-registration-wrapper">
        <div className="card border rounded-0 shadow-sm flex-grow-1 d-flex flex-column ss-portal-user-registration-card" style={{ height: '100vh' }}>
          {/* Fixed Header */}
          <div className="card-header border-bottom pt-4 pb-3 ss-portal-user-registration-header" style={{ flexShrink: 0 }}>
            <div className="d-flex align-items-center mb-3 col-12">
              <div className="symbol symbol-50 symbol-light-primary me-4">
                <div className="symbol-label">
                  <i className="fas fa-layer-group text-primary"></i>
                </div>
              </div>
              <div>
                <h2 className="card-title text-gray-900 mb-1 ss-portal-user-registration-title">
                  {requestedByManager ? 'SpendSail T&E User Request (Manager)' : 'SpendSail T&E User Request'}
                </h2>
                <p className="text-muted mb-0">
                  {requestedByManager
                    ? 'Create and approve a new user. Higher management is notified by division; a CC request is opened when Corporate Credit Card is requested.'
                    : 'Follow the steps below to complete your application'}
                </p>
              </div>
              {roleID && roleID > 0 ? (
                <button
                  className='btn btn-icon btn-sm btn-danger ms-auto'
                  onClick={handleClose}
                  title="Close"
                >
                  <i className="fas fa-times fs-3"></i>
                </button>
              ) : (
                <div className='ms-auto d-flex align-items-center gap-3'>
                  <Link
                    to='auth/login'
                    className='link-primary fs-6 fw-bold'
                  >
                    Login
                  </Link>
                  <button
                    type='button'
                    className='btn btn-icon btn-sm btn-light'
                    onClick={() => navigate('/auth/login')}
                    title="Close"
                  >
                    <i className="fas fa-times fs-3"></i>
                  </button>
                </div>
              )}
            </div>
            {/* Mobile Only Stepper Container */}
            <div className='d-block  w-100'>
              <div className='d-flex align-items-center justify-content-between position-relative'>
                {/* Previous Button - Mobile */}
                <div className='flex-shrink-0 me-2'>
                  <button
                    type='button'
                    className='btn btn-icon btn-light-primary'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                    style={{
                      width: '32px',
                      height: '32px'
                    }}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-2'
                    />
                  </button>
                </div>

                {/* Stepper Steps - Mobile container */}
                <div className='flex-grow-1 mx-2'>
                  <div className='d-flex align-items-center justify-content-between'>
                    {/* Step 1 - Mobile */}
                    <div className={`d-flex flex-column align-items-center text-center position-relative flex-grow-1 ${getStepClass(1)}`} data-kt-stepper-element='nav'>
                      <div className='d-flex align-items-center justify-content-center mb-1'>
                        <div className={`rounded-circle d-flex align-items-center justify-content-center ss-portal-stepper-circle ${isStepActive(1) ? 'active' : isStepCompleted(1) ? 'completed' : ''}`}
                          style={getStepCircleStyle(1)}
                        >
                          {isStepCompleted(1) ? (
                            <i className='fas fa-check fs-6 text-white'></i>
                          ) : (
                            <span className={`fs-7 fw-bold ${isStepActive(1) ? 'text-white' : 'ss-portal-stepper-number'}`}>1</span>
                          )}
                        </div>
                      </div>
                      <div className='w-100'>
                        <span className={`fs-8 fw-bold ${getStepTextColor(1)}`}>{labelKey.userDetails}</span>
                      </div>
                    </div>

                    {/* Connector Line 1 */}
                    <div className='flex-grow-1 mx-1' style={{ maxWidth: '30px' }}>
                      <div className='h-1px bg-secondary bg-opacity-25 w-100 ss-portal-stepper-line'></div>
                    </div>

                    {/* Step 2 - Mobile */}
                    <div className={`d-flex flex-column align-items-center text-center position-relative flex-grow-1 ${getStepClass(2)}`} data-kt-stepper-element='nav'>
                      <div className='d-flex align-items-center justify-content-center mb-1'>
                        <div className={`rounded-circle d-flex align-items-center justify-content-center ss-portal-stepper-circle ${isStepActive(2) ? 'active' : isStepCompleted(2) ? 'completed' : ''}`}
                          style={getStepCircleStyle(2)}
                        >
                          {isStepCompleted(2) ? (
                            <i className='fas fa-check fs-6 text-white'></i>
                          ) : (
                            <span className={`fs-7 fw-bold ${isStepActive(2) ? 'text-white' : 'ss-portal-stepper-number'}`}>2</span>
                          )}
                        </div>
                      </div>
                      <div className='w-100'>
                        <span className={`fs-8 fw-bold ${getStepTextColor(2)}`}>{labelKey.userAddress}</span>
                      </div>
                    </div>

                    {/* Connector Line 2 */}
                    <div className='flex-grow-1 mx-1' style={{ maxWidth: '30px' }}>
                      <div className='h-1px bg-secondary bg-opacity-25 w-100 ss-portal-stepper-line'></div>
                    </div>

                    {/* Step 3 - Mobile */}
                    <div className={`d-flex flex-column align-items-center text-center position-relative flex-grow-1 ${getStepClass(3)}`} data-kt-stepper-element='nav'>
                      <div className='d-flex align-items-center justify-content-center mb-1'>
                        <div className={`rounded-circle d-flex align-items-center justify-content-center ss-portal-stepper-circle ${isStepActive(3) ? 'active' : isStepCompleted(3) ? 'completed' : ''}`}
                          style={getStepCircleStyle(3)}
                        >
                          {isStepCompleted(3) ? (
                            <i className='fas fa-check fs-6 text-white'></i>
                          ) : (
                            <span className={`fs-7 fw-bold ${isStepActive(3) ? 'text-white' : 'ss-portal-stepper-number'}`}>3</span>
                          )}
                        </div>
                      </div>
                      <div className='w-100'>
                        <span className={`fs-8 fw-bold ${getStepTextColor(3)}`}>{labelKey.overview}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Next/Submit Button - Mobile */}
                <div className='flex-shrink-0 ms-2'>
                  {isLastStep ? (
                    <button
                      className='btn btn-sm btn-success'
                      data-kt-stepper-action='submit'
                      disabled={isLoading}
                      onClick={handleSubmit}
                    >
                      {!isLoading && <span className='indicator-label'>{labelKey.submit}</span>}
                      {isLoading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          {labelKey.pleaseWait}...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  ) : (
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary'
                      data-kt-stepper-action='next'
                      onClick={nextStep}
                      style={{
                        width: '32px',
                        height: '32px'
                      }}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-2'
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Scrollable Content Area - This is where your stepper goes */}
          <div className="card-body p-4 overflow-auto flex-grow-1">
            {/* Stepper Container */}
            <div className="card-body pt-0">
              <div
                ref={stepperRef}
                className='stepper stepper-pills stepper-column d-flex flex-column flex-lg-row flex-row-fluid'
                id='kt_modal_create_app_stepper'
              >
                <div className='d-flex d-none justify-content-center justify-content-lg-start flex-row-auto w-100 w-lg-300px position-sticky top-0 start-0 h-100 z-index-3 py-2 py-lg-0'>
                  {/* begin::Nav*/}
                  <div className='stepper-nav ps-lg-10 d-flex flex-row flex-lg-column gap-1 gap-lg-0 d-lg-block d-none'>
                    <div className={`stepper-item ${currentStepIndex === 1 ? 'current' : currentStepIndex > 1 ? 'completed' : ''}`} data-kt-stepper-element='nav'>
                      <div className='stepper-wrapper d-flex align-items-center'>
                        <div className='stepper-icon w-16px h-16px ms-2 ms-lg-0 flex-shrink-0'>
                          <i className='stepper-check fas fa-check fs-5'></i>
                          <span className='stepper-number fs-7'>1</span>
                        </div>
                        <div className='stepper-label ms-2 ms-lg-0'>
                          <h3 className='stepper-title fs-8 fs-lg-5 fw-bold mb-0'>{labelKey.userDetails}</h3>
                          <div className='stepper-desc fs-9 d-none d-lg-block mt-1'>{labelKey.addUserDetail}</div>
                        </div>
                      </div>
                      <div className='stepper-line h-40px d-none d-lg-block'></div>
                    </div>
                    <div className={`stepper-item ${currentStepIndex === 2 ? 'current' : currentStepIndex > 2 ? 'completed' : ''}`} data-kt-stepper-element='nav'>
                      <div className='stepper-wrapper d-flex align-items-center'>
                        <div className='stepper-icon w-16px h-16px ms-2 ms-lg-0 flex-shrink-0'>
                          <i className='stepper-check fas fa-check fs-5'></i>
                          <span className='stepper-number fs-7'>2</span>
                        </div>
                        <div className='stepper-label ms-2 ms-lg-0'>
                          <h3 className='stepper-title fs-8 fs-lg-5 fw-bold mb-0'>{labelKey.userAddress}</h3>
                          <div className='stepper-desc fs-9 d-none d-lg-block mt-1'>{labelKey.addAddressDetail}</div>
                        </div>
                      </div>
                      <div className='stepper-line h-40px d-none d-lg-block'></div>
                    </div>
                    <div className={`stepper-item ${currentStepIndex === 3 ? 'current' : ''}`} data-kt-stepper-element='nav'>
                      <div className='stepper-wrapper d-flex align-items-center'>
                        <div className='stepper-icon w-16px h-16px ms-2 ms-lg-0 flex-shrink-0'>
                          <i className='stepper-check fas fa-check fs-5'></i>
                          <span className='stepper-number fs-7'>3</span>
                        </div>
                        <div className='stepper-label ms-2 ms-lg-0'>
                          <h3 className='stepper-title fs-8 fs-lg-5 fw-bold mb-0'>{labelKey.overview}</h3>
                          <div className='stepper-desc fs-9 d-none d-lg-block mt-1'>{labelKey.reviewAndSubmit}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end::Nav*/}
                </div>
                <div className='flex-row-fluid py-lg-5 px-lg-15'>
                  {/*begin::Form */}
                  <form noValidate id='kt_modal_create_app_form' onSubmit={formik.handleSubmit}>
                    <Step1 formik={formik}
                      departmentLookup={departmentLookup}
                      designationLookup={designationLookup}
                      locationsData={locationsData}
                      getAlldivision={getAlldivision}
                      expenseTypeLookup={expenseTypeLookup}
                      isTravelModuleAccessAvailable={isTravelModuleAccessAvailable}
                      hideManagerLookup={requestedByManager}
                      requireDepartmentDesignation={requestedByManager}
                    />
                    {/* <Step2 formik={formik} /> */}
                    <Step3 formik={formik}
                    />
                    <Step4 formik={formik}
                      isTravelModuleAccessAvailable={isTravelModuleAccessAvailable}
                      requestedByManager={requestedByManager}
                    />

                    {/*begin::Actions - Footer Buttons */}
                    <div className='d-flex flex-stack mt-8 pt-4 border-top ss-portal-user-registration-footer'>
                      <div className='me-2'>
                        <button
                          type='button'
                          className='btn btn-lg btn-light-primary me-3'
                          data-kt-stepper-action='previous'
                          onClick={prevStep}
                          disabled={currentStepIndex === 1}
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr063.svg'
                            className='svg-icon-3 me-1'
                          />{' '}
                          {labelKey.previous}
                        </button>
                      </div>
                      <div>
                        {isLastStep ? (
                          <button
                            type='submit'
                            className='btn btn-lg btn-success me-3'
                            data-kt-stepper-action='submit'
                            disabled={isLoading}
                            onClick={handleSubmit}
                          >
                            {!isLoading && <span className='indicator-label'>{labelKey.submit}</span>}
                            {isLoading && (
                              <span className='indicator-progress' style={{ display: 'block' }}>
                                {labelKey.pleaseWait}...{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        ) : (
                          <button
                            type='button'
                            className='btn btn-lg btn-primary'
                            data-kt-stepper-action='next'
                            onClick={nextStep}
                          >
                            {labelKey.nextStep}{' '}
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr064.svg'
                              className='svg-icon-3 ms-1 me-0'
                            />
                          </button>
                        )}
                      </div>
                    </div>
                    {/*end::Actions */}
                  </form>
                  {/*end::Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

    </>
  )
}